module.exports = __webpack_public_path__ + "img/official.jpg";